import React from 'react'

import {
  AlertTriangleIcon,
  BellOffIcon,
  CheckCircleIcon,
  CheckIcon,
  FileTextIcon,
  FlagIcon,
  GuardsIcon,
  IncidentPriorityIcon,
  MailIcon,
  MapPinIcon,
  MicIcon,
  PhoneOffIcon,
  PhoneOutgoingIcon,
  ReleaseIcon,
  SettingsIcon,
  ShieldIcon,
  ToolIcon,
  XCircleIcon,
} from '@hivewatch/dark'

import { IncidentActionType } from '@/graphql/generated/schemas'

import {
  CannedIncidentActionType,
  ExtendedIncidentActionType,
  NonActionItem,
} from '../../../shared/types/feedTypes'

interface DarkActionIconOptionsI {
  priority?: string | null
}

const resolveColor = (colorScheme: 'dark' | 'light') =>
  colorScheme === 'light'
    ? 'var(--hw-dark-colors-light-icon-secondary)'
    : 'var(--hw-dark-colors-icon-secondary)'

export const ActionIcon = (
  type: string,
  colorScheme: 'dark' | 'light',
  options?: DarkActionIconOptionsI
) => {
  switch (type) {
    case IncidentActionType.AcknowledgementByGuard:
    case IncidentActionType.AcknowledgementByOperator:
      return <ShieldIcon colorScheme={colorScheme} />
    case IncidentActionType.TakeoverByGuard:
      return <GuardsIcon colorScheme={colorScheme} />
    case IncidentActionType.OnScene:
      return <MapPinIcon colorScheme={colorScheme} />
    case IncidentActionType.Cleared:
      return <CheckIcon color={resolveColor(colorScheme)} />
    case IncidentActionType.Resolved:
      return <CheckCircleIcon colorScheme={colorScheme} />
    case IncidentActionType.SetRealToTrue:
      return <AlertTriangleIcon colorScheme={colorScheme} />
    case IncidentActionType.SetRealToFalse:
      return <XCircleIcon colorScheme={colorScheme} />
    case IncidentActionType.ReleaseByGuard:
    case IncidentActionType.ReleaseByOperator:
      return <ReleaseIcon colorScheme={colorScheme} />
    case IncidentActionType.OrderDeviceRepair:
      return <ToolIcon colorScheme={colorScheme} />
    case IncidentActionType.StartEmergencyCall:
      return <PhoneOutgoingIcon colorScheme={colorScheme} />
    case IncidentActionType.EndEmergencyCall:
      return <PhoneOffIcon colorScheme={colorScheme} />
    case IncidentActionType.Flag:
      return <FlagIcon colorScheme={colorScheme} />
    case IncidentActionType.Mute:
      return <BellOffIcon colorScheme={colorScheme} />
    case IncidentActionType.SendEmail:
    case CannedIncidentActionType.Email:
      return <MailIcon colorScheme={colorScheme} />
    case IncidentActionType.SystemPriorityAssignment:
    case ExtendedIncidentActionType.PriorityChange:
    case 'PRIORITY_CHANGE':
      return (
        <IncidentPriorityIcon
          colorScheme={colorScheme}
          priority={options?.priority}
        />
      )
    case NonActionItem.IncidentNote:
      return <FileTextIcon colorScheme={colorScheme} />
    case NonActionItem.AudioMessage:
      return <MicIcon colorScheme={colorScheme} />
    case NonActionItem.SystemAction:
      return <SettingsIcon colorScheme={colorScheme} />
  }
}
